import React, { useEffect } from "react";
import imge from "../images/img_1.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import "./JobCard2.css";
import { Link } from "react-router-dom";

const JobCard2 = ({
  id,
  position,
  company,
  type,
  location,
  img,
  companyLogo,
}) => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
  }, []);

  return (
    <>
      <Link
        style={{ textDecoration: "none", color: "inherit" }}
        to={`/jobSingle/${id}`}
      >
        <div class="job-grid" data-aos="fade-down" data-aos-id="JobCard">
          <div class="job-title-sec">
            <div class="s1">
              <img src={companyLogo?.url ? companyLogo.url : imge} alt="" />
            </div>
            <div className="s2">
              <h6>{company}</h6>
              <span>{position}</span>
            </div>
          </div>
          <div className="s3">
            <span class="job-lctn">{location}</span>
            <button>Apply Now</button>
          </div>
          <span
            className={`fullTime badge badge-${
              type === "full-time" ? "success" : "danger"
            }`}
          >
            {type}
          </span>
        </div>
      </Link>
    </>
  );
};

export default JobCard2;
